import "react-app-polyfill/ie11";
import "core-js/stable";
import React, { useState, useCallback, useEffect, useRef } from "react";
import { hooks } from "botframework-webchat-component";
import contactUsGDM from '../util/contactUsGDM.json';
import Select from "react-select";

const { useSendPostBack } = hooks;

const ContactUs = ({ content, store }) => {
    const [division, setDivision] = useState(null);
    const [lob, setLob] = useState(null);
    const [isSubmitted, setIsSubmitted] = useState(false);
    const sendPostBack = useSendPostBack();
    const divisionOptionList = useRef([]);
    const lobOptionList =  useRef([]);

    if(contactUsGDM) {
        divisionOptionList.current = [];
        Object.keys(contactUsGDM).forEach((item) => {
            divisionOptionList.current.push({ value: item, label: item });
        });
    }
    useEffect(() => { 
    },[]);

    // Handle change division dropdown option
    const handleChangeDivision = useCallback(
        (e) => {
            setDivision(e);
            setLob("");
            lobOptionList.current = [];
            if(contactUsGDM[e.value] && contactUsGDM[e.value].length !== 0) {
              contactUsGDM[e.value].map((item) => {
                  return lobOptionList.current.push({ value: item, label: item });
                  });
          }
          else {
            lobOptionList.current.push({ value: '', label: 'Not Applicable' });
            setLob({ value: '', label: 'Not Applicable' });
          }
        },
        [setDivision, setLob]
      );

      // Handle change LOB dropdown option
      const handleChangeLOB = useCallback(
        (e) => {
            setLob(e);
        },
        [setLob]
      );

      // Handle submit button click
      const handleSubmitClick = useCallback(
        event => {
            event.preventDefault();
            const submitObject = {
                'division':division.value,
                'lob':lob.value
            };
            setIsSubmitted(true);
            sendPostBack(submitObject);    
        },
        [division,lob,setIsSubmitted,sendPostBack]); 

    return (
        <div className="kBForm">
                <div className="webformInputLabel">
                    <span className="webformFieldTitle kBFields">Select Division:</span>
                </div>
                <div className="input-wrap">
                    <Select
                        className="input-wrap-text-plugin kBFieldSelect"
                        name="division"
                        id="division"
                        options={divisionOptionList.current}
                        placeholder="Select division"
                        value={division}
                        onChange={(e) => handleChangeDivision(e)}
                        isSearchable={true}
                    />
                </div>
              
                <div className="webformInputLabel">
                    <span className="webformFieldTitle kBFields">Line Of Business:</span>
                </div>
                <div className="input-wrap">
                    <Select
                        className="input-wrap-text-plugin kBFieldSelect"
                        name="lob"
                        id="lob"
                        options={lobOptionList.current}
                        placeholder="Please select division first"
                        value={lob}
                        onChange={(e) => handleChangeLOB(e)}
                        isSearchable={true}
                    />
                </div>
                
                <div className="kBFormSubmitDiv">
                    <button onClick={handleSubmitClick}
                        className="webformButton primary kBFormSubmit"
                        disabled={!division || !lob || isSubmitted}>
                        Submit</button>
                </div>
                <br/>
        </div>
    );
};
export default ContactUs;